import {useReducer, useEffect} from "react"
import {EcpWorkflowContext} from "../contexts/EcpWorkflowContext"
import ecpWorkflowRecucer from "../reducers/ecpWorkflowRecucer"

const initialState = {
    isConfirmationModal: {
        modal: false,
        id: null,
        type: null,
    },
    isGlossaryModal: {
        modal: false,
        type: null,
        index: null,
    },
}

export default function EcpWorkflowProvider({children}) {
    const [ecpWorkflowContext, setEcpWorkflowAction] = useReducer(
        ecpWorkflowRecucer,
        initialState,
    )

    useEffect(() => {
        if (ecpWorkflowContext) {
            localStorage.setItem("ecpWorkflowContext", JSON.stringify(ecpWorkflowContext))
        } else {
            localStorage.removeItem("ecpWorkflowContext")
        }
    }, [ecpWorkflowContext])

    return (
        <EcpWorkflowContext.Provider value={{ecpWorkflowContext, setEcpWorkflowAction}}>
            {children}
        </EcpWorkflowContext.Provider>
    )
}